import { SiteLayout } from "@/components/site/SiteLayout";
import { FunnelProgress } from "@/components/site/FunnelProgress";
import { formatLongDate, readStoredAppointment } from "@/services/bookingService";
import { school } from "@/data/schoolData";
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

function FunnelPage({ children, title, description, path, progress, testId }) {
  return <SiteLayout title={title} description={description} path={path} funnel><div className="funnel-page" data-testid={testId}><FunnelProgress value={progress} /><div className="funnel-content">{children}</div></div></SiteLayout>;
}

export function ConfirmationPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const [appointment, setAppointment] = useState(() => location.state?.appointment || readStoredAppointment());
  useEffect(() => {
    const stored = readStoredAppointment();
    if (stored) setAppointment(stored);
    else navigate("/schedule", { replace: true });
  }, [navigate]);
  if (!appointment) return null;
  const dateLabel = appointment.dateLabel || formatLongDate(appointment.date);
  return <FunnelPage title={`You’re All Set | ${school.name}`} description={`Your first lesson time is confirmed at ${school.name}.`} path="/confirmation" progress={100} testId="confirmation-funnel-page"><div className="confirmation-mark" aria-hidden="true">✓</div><h1 data-testid="confirmation-funnel-title">You&apos;re all set!</h1><p className="confirmation-message" data-testid="confirmation-message">You are all set! Your intro lesson is scheduled for {dateLabel} at {appointment.time}, and we’re looking forward to meeting you!<br />Wear comfortable clothes like workout gear and bring a bottle of water.</p></FunnelPage>;
}
